import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      position: 'relative',
      fontSize: '16px',
      padding: 16,
      border: 'solid 1px #2962FF',
      borderRadius: 6,
      cursor: 'text',

      '& div.public-DraftEditorPlaceholder-inner': {
        color: '#93a1b6',
        position: 'absolute',
      },
    },
    toolbar: {
      position: 'absolute',
      right: 10,
      top: 10,
      zIndex: 2,
      background: 'rgba(12,15,20,0.5)',
      padding: 10,

      '& > div': {
        display: 'flex',
        gap: 5,
        alignItems: 'center',
        flexDirection: 'column',
      },

      '& img': {
        filter: 'invert(100%)',
        cursor: 'pointer',
      },
    },
  }),
);
